import { render, staticRenderFns } from "./RespostaForm.vue?vue&type=template&id=55e702c1&scoped=true&"
import script from "./RespostaForm.vue?vue&type=script&lang=js&"
export * from "./RespostaForm.vue?vue&type=script&lang=js&"
import style0 from "./RespostaForm.vue?vue&type=style&index=0&id=55e702c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e702c1",
  null
  
)

export default component.exports